import React from 'react';
import { ENUM_RIDER_STATUS } from 'utils/enum';

type Props = {
  status: string;
  disableBgColor?: boolean;
  className?: string;
  wrapperClassName?: string;
};

const badgeColor = {
  [ENUM_RIDER_STATUS.SCHEDULED]: 'text-[#F9C320] border-[#F9C320] bg-[#F9C320]/10',
  [ENUM_RIDER_STATUS.AWAITING_APPROVAL]: 'text-blue-5 border-blue-5 bg-blue-5/10',
  [ENUM_RIDER_STATUS.REJECTED]: 'text-[#E60A2B] border-[#E60A2B] bg-[#E60A2B]/10',
  [ENUM_RIDER_STATUS.APPROVED]: 'text-[#3FB827] border-[#3FB827] bg-[#3FB827]/10'
};

const StatusColor = ({ status, disableBgColor = false, className, wrapperClassName }: Props) => {
  return (
    <span
      className={`inline-flex items-center justify-center border  p-1 px-4 rounded-2xl ${
        badgeColor?.[status as keyof typeof badgeColor] ?? 'text-purple] bg-purple/10'
      } ${disableBgColor ? '!bg-transparent !px-0' : ''} ${wrapperClassName}`}>
      <span className={`text-center capitalize font-medium ${className}`}>
        {status.toLowerCase().replaceAll('_', ' ')}
      </span>
    </span>
  );
};

export default StatusColor;
